module.exports = __webpack_public_path__ + "static/img/thumb_15.94e836b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_15.jpg
// module id = Dd75
// module chunks = 0